module.exports = "<div class=\"widgets_date-time widgets_date-time-picker\">\r\n        <i class=\"fa fa-calendar\"ng-if=\"!$ctrl.config.noCalendar\" ng-click=\"$ctrl.calendarOpen()\" aria-hidden=\"true\"></i>\r\n    <input class=\"text-field\" placeholder=\"{{$ctrl.placeholder}}\" ng-model=\"$ctrl.pickerValue\" ng-disabled=\"$ctrl.readOnly\" ng-class=\"{'form-control': $ctrl.formControl, 'plain-text': !$ctrl.formControl}\">\r\n        </input>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ../widgets/date-time-picker/date-time-picker.html
// module id = 738
// module chunks = 0